module.exports = __webpack_public_path__ + "static/media/founder.d087e442.png";